import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ConfigurationStoreService } from '../../services/configuration-store/configuration-store.service';

@Component({
  selector: 'baf-main-view',
  templateUrl: './main-view.component.html',
  styleUrls: ['./main-view.component.css']
})
export class MainViewComponent implements OnInit, AfterViewInit {
  private readonly minimalHeight = 600;
  commonHeight = this.minimalHeight;

  constructor(private configurationStore: ConfigurationStoreService) {}

  @ViewChild('rightPanel')
  rightPanel: ElementRef;

  ngOnInit() {
    this.configurationStore.loadConfiguration();
  }

  ngAfterViewInit() {
    setTimeout(() => this.setCommonHeight());
  }

  onDataLoaded(message: string) {
    this.setCommonHeight();
  }

  private setCommonHeight() {
    const height = this.rightPanel.nativeElement.clientHeight;
    this.commonHeight = Math.max(height, this.minimalHeight);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/main-view/main-view.component.ts